var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"imagePreviewWrapper",style:({ 'background-image': `url(${_vm.previewImage})` }),on:{"click":_vm.selectImage}}),_c('input',{ref:"fileInput",attrs:{"type":"file"},on:{"input":_vm.pickFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }